import { JsonLd } from "react-schemaorg";
import { Organization } from "schema-dts";

const BaseSchema = () => {
  return (
    <JsonLd<Organization>
      item={{
        "@context": "https://schema.org",
        "@type": "Organization",
        sameAs: [],
        name: "Societize",
        description:
          "Societize is a complete simulation in which you are in charge of your own future. Societize is the home of innovation and experience.",
        url: "https://www.societize.app",
        // logo: "",
        foundingDate: "2021",
      }}
    />
  );
};

export default BaseSchema;
